export enum FontStyleEnum {
  BOLD = 'bold',
  ITALIC = 'italic',
  UNDERLINE = 'underline',
}
